export const ICONS_BY_LIBRARY = {
  TablerIconName: [
    'user-circle',
    'gift',
    'discount-2',
    'circle-check',
    'clock',
    'moon',
    'sun',
    'bell',
    'search',
    'grid-alt',
    'menu',
    'x',
    'check',
    'cog',
    'settings',
    'logout',
    'user',
    'share',
    'adjustments-horizontal',
    'wallet',
    'headset',
    'heart',
    'star',
    'home',
    'dashboard',
    'chart',
    'users',
    'folder',
    'file',
    'mail',
    'calendar',
    'plus',
    'minus',
    'trash',
    'edit',
    'copy',
    'filter',
    'sort',
    'download',
    'upload',
    'link',
    'eye',
    'eye-off',
    'lock',
    'unlock',
    'key',
    'cloud',
    'refresh',
    'sync',
    'alert',
    'info',
    'question',
    'warning',
    'error',
    'truck',
    'chevron-down',
    'chevron-up',
    'chevron-left',
    'chevron-right',
    'chevrons-down',
    'chevrons-up',
    'chevrons-left',
    'chevrons-right',
    'toggle-right',
    'toggle-left',
    'ticket',
    'ticket-off',
    'tie',
    'tilt-shift',
    'tilt-shift-off',
    'timeline',
    'tir',
    'tools',
    'tools-off',
    'tools-kitchen',
    'tools-kitchen-off',
    'tools-kitchen-2',
    'tools-kitchen-2-off',
    'toilet-paper',
    'arrow-up',
    'arrow-down',
    'arrow-left',
    'arrow-right',
    'arrows-maximize',
    'arrows-minimize',
    'circle',
    'square',
    'triangle',
    'brand-github',
    'brand-twitter',
    'brand-facebook',
    'brand-linkedin',
    'dots-vertical',
    'dots-horizontal',
    'message',
    'messages',
    'phone',
    'mail-forward',
    'send',
    'shield',
    'shopping-cart',
    'tag',
    'tags',
    'thumb-up',
    'thumb-down',
    'trending-up',
    'trending-down',
    'zoom-in',
    'zoom-out',
    '2fa',
    '3d-cube-sphere',
    '3d-rotate',
    'a-b',
    'a-b-off',
    'abacus',
    'access-point',
    'access-point-off',
    'accessible',
    'accessible-off',
    'activity',
    'activity-heartbeat',
    'ad',
    'ad-2',
    'address-book',
    'adjustments',
    'adjustments-alt',
    'adjustments-off',
    'aerial-lift',
    'affiliate',
    'alarm',
    'alarm-off',
    'album',
    'alert-circle',
    'alert-octagon',
    'alert-triangle',
    'alien',
    'align-center',
    'align-justified',
    'align-left',
    'align-right',
    'ambulance',
    'anchor',
    'anchor-off',
    'angle',
    'ankh',
    'antenna',
    'antenna-bars-1',
    'antenna-bars-2',
    'antenna-bars-3',
    'antenna-bars-4',
    'antenna-bars-5',
    'antenna-bars-off',
    'aperture',
    'api',
    'api-app',
    'api-app-off',
    'api-off',
    'app-window',
    'apple',
    'apps',
    'apps-off',
    'archive',
    'archive-off',
    'armchair',
    'armchair-2',
    'arrow-autofit-content',
    'arrow-autofit-down',
    'arrow-autofit-height',
    'arrow-autofit-left',
    'arrow-autofit-right',
    'arrow-autofit-up',
    'arrow-autofit-width',
    'arrow-back',
    'arrow-back-up',
    'arrow-bar-down',
    'arrow-bar-left',
    'arrow-bar-right',
    'arrow-bar-to-down',
    'arrow-bar-to-left',
    'arrow-bar-to-right',
    'arrow-bar-to-up',
    'arrow-bar-up',
    'click',
    'palette',
    'layout-list',
    'layout-grid',
    'wand',
    'code',
    'book',
  ],

  BoxIconName: [
    'user-circle',
    'bell',
    'search',
    'menu',
    'x',
    'check',
    'grid',
    'cog',
    'log-out',
    'user',
    'share',
    'wallet',
    'headphones',
    'heart',
    'star',
    'home',
    'chart',
    'group',
    'folder',
    'file',
    'envelope',
    'calendar',
    'plus',
    'minus',
    'trash',
    'edit',
    'copy',
    'filter',
    'sort',
    'download',
    'upload',
    'link',
    'show',
    'hide',
    'lock',
    'unlock',
    'key',
    'cloud',
    'refresh',
    'sync',
    'error-circle',
    'info-circle',
    'help-circle',
    'error-triangle',
    'error',
    'balloon',
    'castle',
    'coffee-bean',
    'objects-horizontal-center',
    'objects-horizontal-left',
    'objects-horizontal-right',
    'objects-vertical-bottom',
    'objects-vertical-center',
    'objects-vertical-top',
    'pear',
    'shield-minus',
    'shield-plus',
    'shower',
    'sushi',
    'universal-access',
    'child',
    'horizontal-left',
    'horizontal-right',
    'rfid',
    'vertical-bottom',
    'vertical-top',
    'color',
    'reflect-horizontal',
    'reflect-vertical',
    'home-alt-2',
    'hard-hat',
    'cheese',
    'cart-add',
    'cart-download',
    'no-signal',
    'signal-1',
    'signal-2',
    'signal-3',
    'signal-4',
    'signal-5',
    'lemon',
    'cricket-ball',
    'baguette',
    'bowl-hot',
    'bowl-rice',
    'cable-car',
    'candles',
    'circle-half',
    'circle-quarter',
    'circle-three-quarter',
    'cross',
    'fork',
    'knife',
    'expand-vertical',
    'injection',
    'leaf',
    'math',
    'party',
    'abacus',
    'accessibility',
    'add-to-queue',
    'adjust',
    'alarm',
    'alarm-add',
    'alarm-exclamation',
    'alarm-off',
    'alarm-snooze',
    'album',
    'align-justify',
    'align-left',
    'align-middle',
    'align-right',
    'analyse',
    'anchor',
    'angry',
    'aperture',
    'arch',
    'archive',
    'archive-in',
    'archive-out',
    'area',
    'arrow-back',
    'arrow-from-bottom',
    'arrow-from-left',
    'arrow-from-right',
    'arrow-from-top',
    'arrow-to-bottom',
    'arrow-to-left',
    'arrow-to-right',
    'arrow-to-top',
    'at',
    'atom',
    'award',
    'badge',
    'badge-check',
    'ball',
    'band-aid',
    'bar-chart',
    'bar-chart-alt',
    'bar-chart-alt-2',
    'bar-chart-square',
    'barcode',
    'barcode-reader',
    'baseball',
    'basket',
    'basketball',
    'bath',
    'battery',
    'bed',
    'been-here',
    'beer',
    'bell-minus',
    'bell-off',
    'bell-plus',
    'bible',
    'bitcoin',
    'blanket',
    'block',
    'bluetooth',
    'body',
    'bold',
    'bolt-circle',
    'bomb',
    'bone',
    'bong',
    'book',
    'book-add',
    'book-alt',
    'book-bookmark',
    'book-content',
    'book-heart',
    'bookmark',
    'bookmark-alt',
    'bookmark-alt-minus',
    'bookmark-alt-plus',
    'bookmark-heart',
    'bookmark-minus',
    'bookmark-plus',
    'bookmarks',
    'book-open',
    'book-reader',
    'border-all',
    'border-bottom',
    'border-inner',
    'border-left',
    'border-none',
    'border-outer',
    'border-radius',
    'border-right',
    'border-top',
    'bot',
    'bowling-ball',
    'box',
    'bracket',
    'braille',
    'brain',
    'briefcase',
    'briefcase-alt',
    'briefcase-alt-2',
    'brightness',
    'brightness-half',
    'broadcast',
    'brush',
    'brush-alt',
    'bug',
    'bug-alt',
    'building',
    'play-circle',
    'plug',
    'plus-circle',
    'plus-medical',
    'podcast',
    'pointer',
    'poll',
    'polygon',
    'pound',
    'power-off',
    'printer',
    'pulse',
    'purchase-tag',
    'purchase-tag-alt',
    'pyramid',
    'qr',
    'qr-scan',
    'question-mark',
    'radar',
    'radio',
    'radio-circle',
    'radio-circle-marked',
    'receipt',
    'rectangle',
    'recycle',
    'redo',
    'registered',
    'windows',
    'wine',
    'wink-smile',
    'wink-tongue',
    'won',
    'world',
    'wrench',
    'x-circle',
    'yen',
    'zoom-in',
    'zoom-out',
  ],

  BootstrapIconName: [
    '123',
    'alarm-fill',
    'alarm',
    'align-bottom',
    'align-center',
    'align-end',
    'align-middle',
    'align-start',
    'align-top',
    'alt',
    'app-indicator',
    'app',
    'archive-fill',
    'archive',
    'arrow-90deg-down',
    'arrow-90deg-left',
    'arrow-90deg-right',
    'arrow-90deg-up',
    'arrow-bar-down',
    'arrow-bar-left',
    'arrow-bar-right',
    'arrow-bar-up',
    'arrow-clockwise',
    'arrow-counterclockwise',
    'arrow-down-circle-fill',
    'arrow-down-circle',
    'arrow-down-left-circle-fill',
    'arrow-down-left-circle',
    'arrow-down-left-square-fill',
    'arrow-down-left-square',
    'arrow-down-left',
    'arrow-down-right-circle-fill',
    'arrow-down-right-circle',
    'arrow-down-right-square-fill',
    'arrow-down-right-square',
    'arrow-down-right',
    'arrow-down-short',
    'arrow-down-square-fill',
    'arrow-down-square',
    'arrow-down-up',
    'arrow-down',
    'arrow-left-circle-fill',
    'arrow-left-circle',
    'arrow-left-right',
    'arrow-left-short',
    'arrow-left-square-fill',
    'arrow-left-square',
    'arrow-left',
    'arrow-repeat',
    'arrow-return-left',
    'arrow-return-right',
    'arrow-right-circle-fill',
    'arrow-right-circle',
    'arrow-right-short',
    'arrow-right-square-fill',
    'arrow-right-square',
    'arrow-right',
    'arrow-up-circle-fill',
    'arrow-up-circle',
    'arrow-up-left-circle-fill',
    'arrow-up-left-circle',
    'arrow-up-left-square-fill',
    'arrow-up-left-square',
    'arrow-up-left',
    'arrow-up-right-circle-fill',
    'arrow-up-right-circle',
    'arrow-up-right-square-fill',
    'arrow-up-right-square',
    'arrow-up-right',
    'arrow-up-short',
    'arrow-up-square-fill',
    'arrow-up-square',
    'arrow-up',
    'arrows-angle-contract',
    'arrows-angle-expand',
    'arrows-collapse',
    'arrows-expand',
    'arrows-fullscreen',
    'arrows-move',
    'aspect-ratio-fill',
    'aspect-ratio',
    'asterisk',
    'at',
    'award-fill',
    'award',
    'back',
    'backspace-fill',
    'backspace-reverse-fill',
    'backspace-reverse',
    'backspace',
    'badge-3d-fill',
    'badge-3d',
    'badge-4k-fill',
    'badge-4k',
    'badge-8k-fill',
    'badge-8k',
    'badge-ad-fill',
    'badge-ad',
    'badge-ar-fill',
    'badge-ar',
    'badge-cc-fill',
    'badge-cc',
    'badge-hd-fill',
    'badge-hd',
    'badge-tm-fill',
    'badge-tm',
    'badge-vo-fill',
    'badge-vo',
    'badge-vr-fill',
    'badge-vr',
    'badge-wc-fill',
    'badge-wc',
    'bag-check-fill',
    'bag-check',
    'bag-dash-fill',
    'bag-dash',
    'bag-fill',
    'bag-plus-fill',
    'bag-plus',
    'bag-x-fill',
    'bag-x',
    'bag',
    'bar-chart-fill',
    'bar-chart-line-fill',
    'bar-chart-line',
    'bar-chart-steps',
    'bar-chart',
    'basket-fill',
    'basket',
    'basket2-fill',
    'basket2',
    'basket3-fill',
    'basket3',
    'battery-charging',
    'battery-full',
    'battery-half',
    'battery',
    'bell-fill',
    'bell',
    'bezier',
    'bezier2',
    'bicycle',
    'binoculars-fill',
    'binoculars',
    'blockquote-left',
    'blockquote-right',
    'book-fill',
    'book-half',
    'book',
    'filetype-json',
    'filetype-pptx',
    'filetype-xlsx',
    'calendar-check',
    'calendar-date',
    'calendar-day',
    'calendar-event',
    'calendar-fill',
    'calendar-minus',
    'calendar-month',
    'calendar-plus',
    'calendar-range',
    'calendar-week',
    'calendar-x',
    'camera-fill',
    'camera-reels-fill',
    'camera-reels',
    'camera-video-fill',
    'camera-video-off-fill',
    'camera-video-off',
    'camera-video',
    'camera',
    'cart-check-fill',
    'cart-check',
    'cart-dash-fill',
    'cart-dash',
    'cart-fill',
    'cart-plus-fill',
    'cart-plus',
    'cart-x-fill',
    'cart-x',
    'cart',
    'chat-dots-fill',
    'chat-dots',
    'chat-fill',
    'chat-left-dots-fill',
    'chat-left-dots',
    'chat-left-fill',
    'chat-left-quote-fill',
    'chat-left-quote',
    'chat-left-text-fill',
    'chat-left-text',
    'chat-left',
    'chat-quote-fill',
    'chat-quote',
    'chat-right-dots-fill',
    'chat-right-dots',
    'chat-right-fill',
    'chat-right-quote-fill',
    'chat-right-quote',
    'chat-right-text-fill',
    'chat-right-text',
    'chat-right',
    'chat-square-dots-fill',
    'chat-square-dots',
    'chat-square-fill',
    'chat-square-quote-fill',
    'chat-square-quote',
    'chat-square-text-fill',
    'chat-square-text',
    'chat-square',
    'chat-text-fill',
    'chat-text',
    'chat',
    'check-all',
    'check-circle-fill',
    'check-circle',
    'check-square-fill',
    'check-square',
    'check',
    'check2-all',
    'check2-circle',
    'check2-square',
    'check2',
    'chevron-bar-contract',
    'chevron-bar-down',
    'chevron-bar-expand',
    'chevron-bar-left',
    'chevron-bar-right',
    'chevron-bar-up',
    'chevron-compact-down',
    'chevron-compact-left',
    'chevron-compact-right',
    'chevron-compact-up',
    'chevron-contract',
    'chevron-double-down',
    'chevron-double-left',
    'chevron-double-right',
    'chevron-double-up',
    'chevron-down',
    'chevron-expand',
    'chevron-left',
    'chevron-right',
    'chevron-up',
  ],

  RemixIconName: [
    '24-hours-fill',
    '24-hours-line',
    '4k-fill',
    '4k-line',
    'account-box-fill',
    'account-box-line',
    'account-circle-fill',
    'account-circle-line',
    'account-pin-box-fill',
    'account-pin-box-line',
    'account-pin-circle-fill',
    'account-pin-circle-line',
    'add-box-fill',
    'add-box-line',
    'add-circle-fill',
    'add-circle-line',
    'add-fill',
    'add-line',
    'admin-fill',
    'admin-line',
    'advertisement-fill',
    'advertisement-line',
    'airplay-fill',
    'airplay-line',
    'alarm-fill',
    'alarm-line',
    'alarm-warning-fill',
    'alarm-warning-line',
    'album-fill',
    'album-line',
    'alert-fill',
    'alert-line',
    'aliens-fill',
    'aliens-line',
    'align-bottom',
    'align-center',
    'align-justify',
    'align-left',
    'align-right',
    'align-top',
    'align-vertically',
    'ancient-gate-fill',
    'ancient-gate-line',
    'ancient-pavilion-fill',
    'ancient-pavilion-line',
    'anchor-line',
    'android-fill',
    'android-line',
    'angularjs-fill',
    'angularjs-line',
    'animation-fill',
    'animation-line',
    'anticlockwise-2-fill',
    'anticlockwise-2-line',
    'anticlockwise-fill',
    'anticlockwise-line',
    'app-store-fill',
    'app-store-line',
    'apple-fill',
    'apple-line',
    'apps-2-fill',
    'apps-2-line',
    'apps-fill',
    'apps-line',
    'archive-drawer-fill',
    'archive-drawer-line',
    'archive-fill',
    'archive-line',
    'arrow-down-circle-fill',
    'arrow-down-circle-line',
    'arrow-down-fill',
    'arrow-down-line',
    'arrow-down-s-fill',
    'arrow-down-s-line',
    'arrow-drop-down-fill',
    'arrow-drop-down-line',
    'arrow-drop-left-fill',
    'arrow-drop-left-line',
    'arrow-drop-right-fill',
    'arrow-drop-right-line',
    'arrow-drop-up-fill',
    'arrow-drop-up-line',
    'arrow-go-back-fill',
    'arrow-go-back-line',
    'arrow-go-forward-fill',
    'arrow-go-forward-line',
    'arrow-left-circle-fill',
    'arrow-left-circle-line',
    'arrow-left-down-fill',
    'arrow-left-down-line',
    'arrow-left-fill',
    'arrow-left-line',
    'arrow-left-right-fill',
    'arrow-left-right-line',
    'arrow-left-s-fill',
    'arrow-left-s-line',
    'arrow-left-up-fill',
    'arrow-left-up-line',
    'arrow-right-circle-fill',
    'arrow-right-circle-line',
    'arrow-right-down-fill',
    'arrow-right-down-line',
    'arrow-right-fill',
    'arrow-right-line',
    'arrow-right-s-fill',
    'arrow-right-s-line',
    'arrow-right-up-fill',
    'arrow-right-up-line',
    'arrow-up-circle-fill',
    'arrow-up-circle-line',
    'arrow-up-down-fill',
    'arrow-up-down-line',
    'arrow-up-fill',
    'arrow-up-line',
    'arrow-up-s-fill',
    'arrow-up-s-line',
    'artboard-2-fill',
    'artboard-2-line',
    'artboard-fill',
    'artboard-line',
    'article-fill',
    'article-line',
    'aspect-ratio-fill',
    'aspect-ratio-line',
    'asterisk',
    'at-fill',
    'at-line',
    'attachment-2',
    'attachment-fill',
    'attachment-line',
    'auction-fill',
    'auction-line',
    'award-fill',
    'award-line',
    'baidu-fill',
    'baidu-line',
    'ball-pen-fill',
    'ball-pen-line',
  ],

  FeatherIconName: [
    'activity',
    'airplay',
    'alert-circle',
    'alert-octagon',
    'alert-triangle',
    'align-center',
    'align-justify',
    'align-left',
    'align-right',
    'anchor',
    'aperture',
    'arrow-down',
    'arrow-down-circle',
    'arrow-down-left',
    'arrow-down-right',
    'arrow-left',
    'arrow-left-circle',
    'arrow-right',
    'arrow-right-circle',
    'arrow-up',
    'arrow-up-circle',
    'arrow-up-left',
    'arrow-up-right',
    'at-sign',
    'award',
    'bar-chart',
    'bar-chart-2',
    'battery',
    'battery-charging',
    'bell',
    'bell-off',
    'bluetooth',
    'bold',
    'book',
    'book-open',
    'bookmark',
    'box',
    'briefcase',
    'calendar',
    'camera',
    'camera-off',
    'cast',
    'check',
    'check-circle',
    'check-square',
    'chevron-down',
    'chevron-left',
    'chevron-right',
    'chevron-up',
    'chevrons-down',
    'chevrons-left',
    'chevrons-right',
    'chevrons-up',
    'chrome',
    'circle',
    'clipboard',
    'clock',
    'cloud',
    'cloud-drizzle',
    'cloud-lightning',
    'cloud-off',
    'cloud-rain',
    'cloud-snow',
    'code',
    'codepen',
    'command',
    'compass',
    'copy',
    'corner-down-left',
    'corner-down-right',
    'corner-left-down',
    'corner-left-up',
    'corner-right-down',
    'corner-right-up',
    'corner-up-left',
    'corner-up-right',
    'cpu',
    'credit-card',
    'crop',
    'crosshair',
    'database',
    'delete',
    'disc',
    'dollar-sign',
    'download',
    'download-cloud',
    'droplet',
    'edit',
    'edit-2',
    'edit-3',
    'external-link',
    'eye',
    'eye-off',
    'facebook',
    'fast-forward',
    'feather',
    'file',
    'file-minus',
    'file-plus',
    'file-text',
    'film',
    'filter',
    'flag',
    'folder',
    'folder-minus',
    'folder-plus',
    'gift',
    'git-branch',
    'git-commit',
    'git-merge',
    'git-pull-request',
    'github',
    'gitlab',
    'globe',
    'grid',
    'hard-drive',
    'hash',
    'headphones',
    'heart',
    'help-circle',
    'home',
    'image',
    'inbox',
    'info',
    'instagram',
    'italic',
    'layers',
    'layout',
    'life-buoy',
    'link',
    'link-2',
    'linkedin',
    'list',
    'loader',
    'lock',
    'log-in',
    'log-out',
    'mail',
    'map',
    'map-pin',
    'maximize',
    'maximize-2',
    'menu',
    'message-circle',
    'message-square',
    'mic',
    'mic-off',
    'minimize',
    'minimize-2',
    'minus',
    'minus-circle',
    'minus-square',
    'monitor',
    'moon',
    'more-horizontal',
    'more-vertical',
    'move',
    'music',
    'navigation',
    'navigation-2',
    'octagon',
    'package',
    'paperclip',
    'pause',
    'pause-circle',
    'percent',
    'phone',
    'phone-call',
    'phone-forwarded',
    'phone-incoming',
    'phone-missed',
    'phone-off',
    'phone-outgoing',
    'pie-chart',
    'play',
    'play-circle',
    'plus',
    'plus-circle',
    'plus-square',
    'pocket',
    'power',
    'printer',
    'radio',
    'refresh-ccw',
    'refresh-cw',
    'repeat',
    'rewind',
    'rotate-ccw',
    'rotate-cw',
    'rss',
    'save',
    'scissors',
    'search',
    'send',
    'server',
    'settings',
    'share',
    'share-2',
    'shield',
    'shield-off',
    'shopping-bag',
    'shopping-cart',
    'shuffle',
    'sidebar',
    'skip-back',
    'skip-forward',
    'slack',
    'slash',
    'sliders',
    'smartphone',
    'speaker',
    'square',
    'star',
    'stop-circle',
    'sun',
    'sunrise',
    'sunset',
    'tablet',
    'tag',
    'target',
    'terminal',
    'thermometer',
    'thumbs-down',
    'thumbs-up',
    'toggle-left',
    'toggle-right',
    'trash',
    'trash-2',
    'trending-down',
    'trending-up',
    'triangle',
    'truck',
    'tv',
    'twitter',
    'type',
    'umbrella',
    'underline',
    'unlock',
    'upload',
    'upload-cloud',
    'user',
    'user-check',
    'user-minus',
    'user-plus',
    'user-x',
    'users',
    'video',
    'video-off',
    'voicemail',
    'volume',
    'volume-1',
    'volume-2',
    'volume-x',
    'watch',
    'wifi',
    'wifi-off',
    'wind',
    'x',
    'x-circle',
    'x-square',
    'zap',
    'zap-off',
    'zoom-in',
    'zoom-out',
  ],
} as const;
